export const getFullHeightPreviewDimensions = ({
  device,
  canvasWidth,
  canvasHeight,
}) => {
  const availableWidth = Math.max(canvasWidth || device.w, 1);
  const availableHeight = Math.max(canvasHeight || device.h, 1);
  const scale = Math.min(availableWidth / device.w, 1);

  return {
    scale,
    scaledWidth: Math.max(Math.round(device.w * scale), 1),
    scaledHeight: Math.max(Math.round(availableHeight), 1),
    viewportHeight: Math.max(Math.round(availableHeight / scale), 1),
  };
};
